import { gql } from '@apollo/client';
const GET_ENTITY_SCHEMAS = gql`
  query getEntitySchemas($identifier: String) {
    getEntitySchemas(identifier: $identifier) {
      id
      identifier
      actions
      dynamicProperties
      properties
      relations
    }
  }
`;
const generateQuery = queryString => gql`
  query getEntityData {
    ${queryString}
  }
`;
const generateWhereQuery = queryString => gql`
  query getEntityData($where: JSON){
    ${queryString}
  }
`;
const generateQueryString = (action, query, props) => `
  ${query}: ${action}(where: $where){
    id
    ${props}
  }
`;
const generateIdsQuery = (query, props, action, ids) => `
  ${query}: ${action}(where: { id: { _in: ${JSON.stringify(ids)} } }){
    id
    ${props}
  }
`;
const generateFiltersQuery = (query, props, rawQUery, filterQueryKey) => `
  ${query}:  searchPublishedContent(rawQueryStringified: ${JSON.stringify(rawQUery)}){
    results {
      ...on ${filterQueryKey} {
        id
        ${props}
      }
    }
  }
`;
export { GET_ENTITY_SCHEMAS, generateQuery, generateQueryString, generateIdsQuery, generateFiltersQuery, generateWhereQuery };
//# sourceMappingURL=queries.js.map